import accessors from '../accessors';
import hooks from '../../hooks';
import isReloadRequired from '../verifiers/is-reload-required';
import isReloadSupposed from '../verifiers/is-reload-supposed';

const logAfterReloadAction = () => (next) => (action) => {
  if (!isReloadSupposed(action)) {
    next(action);
    return;
  }

  if (isReloadRequired(action)) {
    hooks.operations.subscribe(
      hooks.availableHooks.ON_SITE_LOADED,
      () => {
        accessors.getLogger().log(`${action.type} action is finished`, { action });
      },
      { once: true }
    );
  } else {
    accessors.getLogger().log(`${action.type} action is finished`, { action });
  }

  next(action);
};

export default logAfterReloadAction;
